import React, { useState } from 'react';

const Tds = () => {
  const [selectedTopic, setSelectedTopic] = useState('itr');

  return (
    <div className="max-w-4xl mx-auto p-4 space-y-6">
        <h1 className="text-3xl md:text-4xl font-bold text-center text-[#333333] mb-10 border-b-2 pb-2 border-[#b7b7a1]"> ITRs, TDS, TDS Filing </h1>

           <p className="text-md text-justify text-[#444] mb-8">Our experienced auditors and tax consultants provide exceptional support to customers in filing their income tax returns, ensuring compliance with all applicable laws and regulations. We guide clients through the entire process, from collecting necessary documentation and calculating taxable income to preparing and submitting accurate tax returns. In addition, we assist with the timely payment of Tax Deducted at Source (TDS), managing the complexities of TDS compliance to help our customers avoid penalties. Our experts also handle TDS return filings, ensuring that all deductions are reported correctly and on time. With our comprehensive understanding of tax regulations, we offer valuable insights and personalized strategies to optimize tax liabilities, empowering our clients to navigate their tax responsibilities with confidence and ease.</p>
      <div className="flex gap-4 mb-4">
        <button
          className={`px-4 py-2 rounded-full ${selectedTopic === 'itr' ? 'bg-[#b7b7a1] text-white' : 'bg-gray-200'}`}
          onClick={() => setSelectedTopic('itr')}
        >
          Income Tax Return (ITR)
        </button>
        <button
          className={`px-4 py-2 rounded-full ${selectedTopic === 'tds' ? 'bg-[#b7b7a1] text-white' : 'bg-gray-200'}`}
          onClick={() => setSelectedTopic('tds')}
        >
          TDS
        </button>
        <button
          className={`px-4 py-2 rounded-full ${selectedTopic === 'tdsFiling' ? 'bg-[#b7b7a1] text-white' : 'bg-gray-200'}`}
          onClick={() => setSelectedTopic('tdsFiling')}
        >
          TDS Filing
        </button>
      </div>

      {selectedTopic === 'itr' && (
        <>
          <h2 className="text-xl font-bold">Filing Income Tax Returns (ITRs)</h2>
          <p>Filing income tax returns (ITRs) is an essential requirement for individuals and entities that earn income above a specified threshold. Here are several reasons highlighting the necessity and importance of filing income tax returns:</p>
          <ol className="list-decimal pl-5 space-y-1">
            <li><strong>Legal Obligation:</strong> Compliance with laws and avoiding penalties.</li>
            <li><strong>Assessment of Tax Liability:</strong> Helps determine tax obligations and claim refunds.</li>
            <li><strong>Documentation for Financial Activities:</strong> Acts as proof of income and supports financial applications.</li>
            <li><strong>Facilitating Loans and Credit:</strong> Enhances creditworthiness with banks and lenders.</li>
            <li><strong>Investment and Business Benefits:</strong> Access deductions and maintain compliance.</li>
            <li><strong>Avoiding Future Tax Problems:</strong> Maintains clean records and avoids audits.</li>
            <li><strong>Government Policies and Benefits:</strong> Supports national development and access to schemes.</li>
            <li><strong>Easier Handling of Audits:</strong> Reduces scrutiny and eases documentation.</li>
          </ol>
          <p className="mt-4"><strong>Conclusion:</strong> Filing ITRs is not just a legal duty but a strategic financial practice that supports compliance, credibility, and access to financial services.</p>
        </>
      )}

      {selectedTopic === 'tds' && (
        <>
          <h2 className="text-xl font-bold">Tax Deducted at Source (TDS)</h2>
          <p>Tax Deducted at Source (TDS) is a means of collecting income tax in India where a portion is deducted at payment time. It's applicable on salaries, interest, rent, professional fees, etc.</p>
          <ol className="list-decimal pl-5 space-y-1">
            <li><strong>Preventing Tax Evasion:</strong> Collects tax upfront and reduces evasion.</li>
            <li><strong>Regular Tax Collection:</strong> Ensures steady revenue throughout the year.</li>
            <li><strong>Ease of Tax Administration:</strong> Simplifies compliance for government and taxpayers.</li>
            <li><strong>Liability Redistribution:</strong> Broadens the tax base across payers.</li>
            <li><strong>Encouraging Compliance:</strong> Keeps taxpayers accountable year-round.</li>
            <li><strong>Contribution to Government Revenue:</strong> A major source of national income.</li>
          </ol>
          <p className="mt-4"><strong>Conclusion:</strong> TDS plays a vital role in ensuring timely tax collection, reducing evasion, and maintaining a well-functioning tax system.</p>
        </>
      )}

      {selectedTopic === 'tdsFiling' && (
        <>
          <h2 className="text-xl font-bold">TDS Filing</h2>
          <p>Filing TDS returns involves reporting the TDS deducted from payments and depositing it with the government. It's mandatory for all deductors.</p>
          <ol className="list-decimal pl-5 space-y-1">
            <li><strong>Legal Requirement:</strong> Non-filing leads to penalties and legal trouble.</li>
            <li><strong>Transparency and Accountability:</strong> Documents tax transactions with the government.</li>
            <li><strong>Claiming TDS Credit:</strong> Ensures payees can claim tax credits via Form 26AS.</li>
            <li><strong>Avoiding Penalties:</strong> Timely filing avoids fines and interest charges.</li>
            <li><strong>Facilitating Input Tax Credit:</strong> Helps businesses stay tax-compliant and maximize credits.</li>
            <li><strong>Ease of Audits:</strong> Well-documented TDS records simplify audits.</li>
            <li><strong>Establishing Credibility:</strong> Reflects sound financial practices.</li>
            <li><strong>Policy Compliance:</strong> Aligns with national tax policy objectives.</li>
          </ol>
          <p className="mt-4"><strong>Conclusion:</strong> TDS filing is essential for ensuring accurate tax records, enabling recipients to claim credits, and maintaining compliance with Indian tax laws.</p>
        </>
      )}
    </div>
  );
};

export default Tds;
